<template>
    <div class="cell-wrapper" :style="wrapperStyle">
        <component :is="$attrs.componentName" v-bind="$attrs.componentProps" />
    </div>
</template>

<script>
export default {
    name: 'CellWrapper',
    inheritAttrs: false,
    props: {
        display: {
            type: String,
            default: 'flex',
        },
        alignItems: {
            type: String,
            default: 'center',
        },
        height: {
            type: String,
            default: '100%',
        },
    },
    computed: {
        wrapperStyle() {
            return {
                alignItems: this.alignItems,
                display: this.display,
                height: this.height,
            };
        },
    },
};
</script>
